import { render, staticRenderFns } from "./HiddenField.vue?vue&type=template&id=0381d583&scoped=true&"
import script from "./HiddenField.vue?vue&type=script&lang=js&"
export * from "./HiddenField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0381d583",
  null
  
)

export default component.exports